<div class="flex flex-col gap-2 text-secondary" [class.items-center]="updatable()">
    <div class="flex flex-row flex-wrap items-center gap-x-0.5 gap-y-1 sm:gap-x-1"
        [attr.role]="updatable() ? 'radiogroup' : null" [attr.aria-label]="accessibilityLabel()">
        @for (star of starSlots; track star) {
        @if (updatable()) {
        <button type="button"
            class="inline-flex touch-manipulation items-center justify-center rounded-md p-1.5 transition-colors duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[color:var(--ring)] hover:bg-muted/70 dark:hover:bg-white/10"
            role="radio" [attr.aria-checked]="rating() === star" [attr.aria-label]="starOptionLabel(star)"
            (click)="updateRating(star)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" class="pointer-events-none" [class]="starSvgClass(star)"
                aria-hidden="true">
                <path
                    d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
            </svg>
        </button>
        } @else {
        <span class="inline-flex items-center justify-center p-1.5" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round" [class]="starSvgClass(star)">
                <path
                    d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
            </svg>
        </span>
        }
        }
    </div>
</div>
